import type {
  ChartV2Point,
  ChartV2ResolvedSeries,
  ChartV2SeriesType,
} from '../types/chart-v2.types';

const bisectByTime = (data: ChartV2Point[], time: number): number => {
  let lo = 0;
  let hi = data.length;

  while (lo < hi) {
    const mid = (lo + hi) >>> 1;

    if (data[mid].time < time) {
      lo = mid + 1;
    } else {
      hi = mid;
    }
  }

  return lo;
};

export const findNearestPoint = (
  data: ChartV2Point[],
  time: number
): ChartV2Point | null => {
  if (data.length === 0) {
    return null;
  }

  const i = bisectByTime(data, time);

  if (i === 0) {
    return data[0];
  }

  if (i >= data.length) {
    return data[data.length - 1];
  }

  const before = data[i - 1];
  const after = data[i];
  return Math.abs(before.time - time) <= Math.abs(after.time - time)
    ? before
    : after;
};

export interface HitTestResult {
  seriesId: string;
  label: string;
  color: string;
  seriesType: ChartV2SeriesType;
  point: ChartV2Point;
}

export const hitTestAll = (
  series: ChartV2ResolvedSeries[],
  time: number
): HitTestResult[] => {
  const results: HitTestResult[] = [];

  for (const s of series) {
    const p = findNearestPoint(s.data, time);

    if (p) {
      results.push({
        seriesId: s.id,
        label: s.label,
        color: s.color,
        seriesType: s.seriesType,
        point: p,
      });
    }
  }

  return results;
};
